import { ResponsiveCard } from '../../molecules/card/Card';
import { PageSectionForCards } from '../../molecules/pageSection/PageSection';

export function YourDataSegment() {
    return (
        <PageSectionForCards
            chapterTitle="Je dossier"
            md={12}
        >
            <ResponsiveCard
                body="Vraag hier jouw gegevens op uit ons systeem"
                cardTitle="Vraag je gegevens op"
                lg={12}
                linksText={['Vraag gegevens op']}
                linksTo={['/yourData']}
            />
        </PageSectionForCards>
    );
}
